import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthService from '../services/AuthService';
import { isPathAllowed, TIER_HOME } from '../config/pageAccess';

// Route guard: unauthenticated users are sent to /login and returned
// to their original destination after signing in. Authenticated users whose access
// tier can't see the current page are redirected to their tier's home page.
export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const tier = AuthService.getUser()?.accessTier;
  if (!isPathAllowed(location.pathname, tier)) {
    return <Navigate to={TIER_HOME[tier] || '/dashboard'} replace />;
  }
  return children;
}
